
import ChallengeBox from "@/components/Base/ChallengeBox.vue";
import { ChallengeData } from "@/models/Base/ChallengeData";
import { DropDownItem } from "@/models/Base/GlobalData";
import { Game } from "@/models/Game";
import { Quests } from "@/models/MapPois/Quest/Quests";
import { Q_QUEST_TYPE } from "@/models/MapPois/Quest/QuestsEnum";
import { cloneDeep } from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { UserData } from "@/models/User";

@Component({
  components: {
    ChallengeBox,
  },
})
class QuestGeneral extends Vue {
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: null }) readonly questData!: Quests;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  questType = "Main";
  cloneQuestData = {} as Quests;

  get getChallengeData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    try {
      challengeData.text = this.questData.desc.en || "";
      if (this.questData.imgs !== undefined) {
        challengeData.image = this.questData.imgs;
      } else {
        challengeData.image = "";
      }
      challengeData.audio = { en: "" };
      return challengeData;
    } catch (error) {
      console.log(error);
      return challengeData;
    }
  }
  get generateLink(): string {
    return (
      process.env.VUE_APP_DATABASEURL +
      "/quests/" +
      this.gameData.key +
      "/" +
      this.questData.key
    );
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/quest/"
    );
  }

  get getUserData(): UserData {
    return this.$store.state.authenication.userData;
  }

  get getQuestType(): DropDownItem[] {
    return [
      { value: Q_QUEST_TYPE.MAIN, text: "Main" },
      { value: Q_QUEST_TYPE.PRIMARY, text: "Primary" },
      { value: Q_QUEST_TYPE.SECONDARY, text: "Secondary" },
      { value: Q_QUEST_TYPE.MISC, text: "Misc" },
    ];
  }

  onDataChange(data: any): void {
    this.questData.desc.en = data.text;
    this.questData.imgs = data.image;
    this.onValueChanged();
  }

  onValueChanged(): void {
    this.$emit("updateTempObject", this.questData);
  }

  created(): void {
    this.cloneQuestData = cloneDeep(this.questData);
  }

  @Validations()
  validations = {
    questData: {
      title: {
        en: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(160),
        },
      },
    },
  };
}

export default QuestGeneral;
